import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { OrderType } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './terms-and-conditions.dialog.html',
    styleUrls: ['./terms-and-conditions.dialog.scss'],
})
export class TermsAndConditionsDialog extends BaseDialog implements AfterViewInit, OnDestroy, OnInit {
    public OrderType: typeof OrderType = OrderType;
    public type: string;

    constructor(el: ElementRef, parentEvents: ParentEvents, renderer: Renderer2, @Inject(MAT_DIALOG_DATA) public orderType: OrderType) {
        super(parentEvents, el, renderer);
    }

    ngOnInit() {
        if (this.orderType === OrderType.SUBSCRIPTION || this.orderType === OrderType.SUBSCRIPTION_PERIOD) {
            this.type = 'terms.subscription';
        } else if (this.orderType === OrderType.REFUND || this.orderType === OrderType.REFUND_PERIOD) {
            this.type = 'terms.refund';
        } else {
            this.type = 'terms.transfer';
        }
    }
}
